var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"grid-x align-center client-logos"},[_c('div',{staticClass:"cell medium-offset-0 medium-9 middle-offset-0 middle-12 large-offset-0 large-12"},[_c('div',{staticClass:"grid-x small-up-2 medium-up-2 middle-up-4 large-up-4 align-middle logo-links"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c9c6d5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientLogos.vue
// module id = 381
// module chunks = 0